import React from 'react';
import TopStepAccountPage from './TopStepAccountPage';

const TopStepAccount3Page: React.FC = () => (
  <TopStepAccountPage
    accountLabel="TopStep Account 3 (Kevin)"
    accountMatcher={(accts) => accts.find(a => a.accountName.includes('572700-47336468'))}
    challengeParams={{ target: 4500, hardMax: 2000, internalStop: 1700, dailyCap: 600, accountSize: 50000 }}
    chipLabel="ACCOUNT 3"
    chipColor="#81C784"
  />
);

export default TopStepAccount3Page;
